import { useMemo } from "react";
import { parseMoodTimestamp } from "../../../utils/common/timestampUtils";
import { getWeekDays, isSameDay } from "../../../utils/common/weekUtils";
import type { Mood } from "../../../types/models";

export interface WeekData {
  key: string;
  weekdays: Date[];
}

export function useMoodFiltering(moods: Mood[], selectedWeek: string): Mood[] {
  const selectedWeekData = useMemo<WeekData | null>(() => {
    if (!selectedWeek) return null;

    const mondayDate = new Date(selectedWeek);
    if (isNaN(mondayDate.getTime())) return null;

    return {
      key: selectedWeek,
      weekdays: getWeekDays(mondayDate),
    };
  }, [selectedWeek]);

  const filteredMoods = useMemo((): Mood[] => {
    if (!selectedWeek || !selectedWeekData) {
      return moods;
    }

    const weekdays = selectedWeekData.weekdays;
    return moods.filter((mood: Mood) => {
      const moodDate = parseMoodTimestamp(mood);
      if (!moodDate) return false;
      return weekdays.some((weekday) => isSameDay(moodDate, weekday));
    });
  }, [moods, selectedWeek, selectedWeekData]);

  console.log("filteredMoods -> " + JSON.stringify(filteredMoods));
  return filteredMoods;
}
